import { render } from "./monday.vue?vue&type=template&id=4535abeb"
import script from "./monday.vue?vue&type=script&lang=js"
export * from "./monday.vue?vue&type=script&lang=js"

import "./monday.vue?vue&type=style&index=0&id=4535abeb&lang=scss"
script.render = render

export default script